import TimeService from '../services/time-service';

export default function (date: number): string | void {
	return TimeService.fromNow(date);
}
